import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// local components
import CamperSessionLink from './CamperSessionLink'
import EligibleActions from '../../../../ExpressCheckIn/CampersOverview/CamperRow/CamperSessionRow/EligibleActions'
import SoftCloseRestrictionNotice from '../../../../Plans/Campers/Camper/SoftCloseRestrictionNotice'

const Session = props => {
  const { camper, camperSession } = props

  const { registered, availableDays, usedDays, unlimitedDays, session } =
    camperSession

  if (!registered) {
    return null
  }

  return (
    <Box
      sx={{
        py: 2,
        borderBottom: 1,
        borderColor: 'divider',
        '&:last-child': { borderBottom: 0 }
      }}
    >
      <Grid container spacing={2}>
        {/* First 3 columns - always together */}
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={4} sm={4}>
              <Box>
                {/* mobile only label: */}
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={{ display: { xs: 'block', sm: 'none' } }}
                >
                  Camp Session
                </Typography>
                <Typography variant='body1'>{session.name}</Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Box>
                {/* mobile only label: */}
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={{ display: { xs: 'block', sm: 'none' } }}
                >
                  Days Remaining
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant='body1'>
                    {unlimitedDays ? 'Unlimited' : availableDays}
                  </Typography>
                  {!unlimitedDays && (
                    <Link
                      sx={{ fontSize: '0.875rem' }}
                      component={RouterLink}
                      to='/plans/cart'
                      underline='always'
                    >
                      add days »
                    </Link>
                  )}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Box>
                {/* mobile only label: */}
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={{ display: { xs: 'block', sm: 'none' } }}
                >
                  Days Used
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant='body1'>{usedDays}</Typography>
                  <CamperSessionLink
                    camper={camper}
                    camperSession={camperSession}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* Button column - full width on small screens, right-aligned on large */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              textAlign: { xs: 'center', sm: 'right' },
              mt: { xs: 2, sm: 0 }
            }}
          >
            {camperSession.eciStatus &&
              camperSession.eciStatus.length === 0 && (
                <EligibleActions
                  camper={camper}
                  camperSession={camperSession}
                  showName={false}
                />
              )}
          </Box>
        </Grid>
      </Grid>

      {(camperSession.plans || [])
        .filter(plan => plan.softCloseRestriction)
        .map(plan => (
          <SoftCloseRestrictionNotice
            key={plan.id}
            restriction={plan.softCloseRestriction}
            sessionId={session.id}
            registeredAt={plan.registeredAt}
          />
        ))}
    </Box>
  )
}

export default Session
